/* eslint-disable */
export default {
  dialPlaceholder: '输入姓名或号码',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
